'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEnvelope$002dId$0024 from "./presto.types$-Envelope-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$34() {
  this.bgn = null;
  this.bgl = null;
  this.bgm = false;
  this.bgj = null;
  this.bgk = false;
  this.bgo = false;
  this.bgp = false;
  this.bgn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$34 as $c_Lpresto_PrestoRouter$$anon$34 };
$p = $c_Lpresto_PrestoRouter$$anon$34.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$34;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$34() {
}
export { $h_Lpresto_PrestoRouter$$anon$34 as $h_Lpresto_PrestoRouter$$anon$34 };
$h_Lpresto_PrestoRouter$$anon$34.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.bgn;
});
$p.t = (function() {
  if ((!this.bgm)) {
    this.bgl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bgm = true;
  }
  return this.bgl;
});
$p.ad = (function() {
  if ((!this.bgk)) {
    this.bgj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEnvelope$002dId$0024.$m_Lpresto_types$EnvelopeId$().cHt(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bgk = true;
  }
  return this.bgj;
});
$p.v = (function() {
  if ((!this.bgp)) {
    this.bgo = false;
    this.bgp = true;
  }
  return this.bgo;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$34 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$34, "presto.PrestoRouter$$anon$34", ({
  O9: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$34 as $d_Lpresto_PrestoRouter$$anon$34 };
//# sourceMappingURL=presto.-Presto-Router$$anon$34.js.map
